var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCondiciones01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 50V25.8697L0 13.6625V35.2229C0 36.0373 0.201563 36.7945 0.604688 37.4944C1.00594 38.1943 1.56188 38.7478 2.2725 39.155L21.0938 50ZM23.9062 50L42.7275 39.1578C43.44 38.7507 43.9969 38.1971 44.3981 37.4972C44.7994 36.7954 45 36.0373 45 35.2229V13.6625L23.9062 25.8697V50ZM34.2197 16.6573L43.4362 11.3657L24.7725 0.6136C24.06 0.204533 23.3025 0 22.5 0C21.6975 0 20.94 0.204533 20.2275 0.6136L13.4297 4.53727L34.2197 16.6573ZM22.5 23.4491L31.4072 18.2842L10.5244 6.20356L1.60313 11.3291L22.5 23.4491Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondiciones01);
export default __webpack_public_path__ + "static/media/Condiciones01.f331a4fab1de829276365d83b9938e43.svg";
export { ForwardRef as ReactComponent };